(function () {
  'use strict';

  function init(root) {
    var endpoint = (root.getAttribute('data-endpoint-url') || '').trim();
    var form = root.querySelector('.rda-form');
    if (!form) return;

    var submitBtn = form.querySelector('.rda-submit');
    var statusOk = root.querySelector('[data-status="ok"]');
    var statusErr = root.querySelector('[data-status="err"]');
    var statusNotReady = root.querySelector('[data-status="notready"]');

    function hideStatuses() {
      [statusOk, statusErr, statusNotReady].forEach(function (el) {
        if (el) el.classList.remove('active');
      });
    }

    function showStatus(el) {
      hideStatuses();
      if (el) {
        el.classList.add('active');
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    // Recognition chips: drive the selected look directly from JS rather
    // than leaning on the CSS :checked sibling selector alone — some global
    // theme stylesheets can out-specificity a scoped rule, which is why the
    // chips looked unresponsive even though the checkbox itself was toggling.
    var recognitionGroup = root.querySelector('[data-recognition-group]');
    var otherWrap = root.querySelector('[data-other-wrap]');
    if (recognitionGroup) {
      var otherCheckbox = recognitionGroup.querySelector('input[data-is-other="true"]');
      recognitionGroup.querySelectorAll('input[type="checkbox"]').forEach(function (box) {
        var chipLabel = box.closest('.rda-chip');
        var syncChip = function () {
          if (chipLabel) chipLabel.classList.toggle('is-checked', box.checked);
          if (otherWrap && box === otherCheckbox) {
            otherWrap.classList.toggle('active', box.checked);
          }
        };
        box.addEventListener('change', syncChip);
        syncChip();
      });
    }

    // File inputs: show chosen filename, soft-validate size
    var MAX_MB = parseInt(root.getAttribute('data-max-mb'), 10) || 3;
    var MAX_BYTES = MAX_MB * 1024 * 1024;
    var DEFAULT_HINT = 'PDF or image, up to ' + MAX_MB + 'MB';
    form.querySelectorAll('input[type="file"]').forEach(function (input) {
      var labelEl = root.querySelector('[data-filename-for="' + input.id + '"]');
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) {
          if (labelEl) labelEl.textContent = DEFAULT_HINT;
          return;
        }
        if (file.size > MAX_BYTES) {
          if (labelEl) labelEl.textContent = 'That file is too large (max ' + MAX_MB + 'MB) — choose another.';
          input.value = '';
          return;
        }
        if (labelEl) labelEl.textContent = file.name;
      });
    });

    // Required recognition checkbox group: at least one must be checked
    function recognitionIsValid() {
      if (!recognitionGroup) return true;
      if (recognitionGroup.getAttribute('data-required') !== 'true') return true;
      var boxes = recognitionGroup.querySelectorAll('input[type="checkbox"]');
      if (!boxes.length) return true;
      return Array.prototype.some.call(boxes, function (b) { return b.checked; });
    }

    // Reads a File as base64 (no data: URL prefix). Apps Script can't
    // reliably parse real multipart file uploads sent via fetch, so files
    // are sent as base64 text inside a JSON payload instead — the
    // well-established pattern for getting attachments into an Apps
    // Script web app from an external site.
    function fileToPayload(file) {
      return new Promise(function (resolve, reject) {
        if (!file) { resolve(null); return; }
        var reader = new FileReader();
        reader.onload = function () {
          var result = reader.result || '';
          var base64 = String(result).split(',')[1] || '';
          resolve({ filename: file.name, mimeType: file.type || 'application/octet-stream', data: base64 });
        };
        reader.onerror = function () { reject(new Error('Could not read file')); };
        reader.readAsDataURL(file);
      });
    }

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      hideStatuses();

      if (!form.reportValidity()) {
        return;
      }
      if (!recognitionIsValid()) {
        showStatus(statusErr);
        if (statusErr) statusErr.textContent = 'Please select at least one way Rook Coffee will be recognized.';
        return;
      }

      if (!endpoint) {
        showStatus(statusNotReady);
        return;
      }

      submitBtn.disabled = true;
      var originalLabel = submitBtn.textContent;
      submitBtn.textContent = 'Submitting…';

      // Collect plain fields (everything except the two file inputs).
      var fields = {};
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || el.type === 'file' || el.type === 'submit' || el.type === 'button') return;
        if (el.type === 'checkbox') {
          if (!el.checked) return;
          if (!fields[el.name]) fields[el.name] = [];
          fields[el.name].push(el.value);
        } else {
          fields[el.name] = el.value;
        }
      });

      var file501c3Input = form.querySelector('input[name="file_501c3"]');
      var fileLetterheadInput = form.querySelector('input[name="file_letterhead"]');

      Promise.all([
        fileToPayload(file501c3Input && file501c3Input.files[0]),
        fileToPayload(fileLetterheadInput && fileLetterheadInput.files[0])
      ])
        .then(function (results) {
          var payload = {
            fields: fields,
            files: {
              file_501c3: results[0],
              file_letterhead: results[1]
            }
          };

          // text/plain avoids a CORS preflight (OPTIONS), which Apps
          // Script web apps don't handle — the body is still JSON.
          return fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain;charset=utf-8' },
            body: JSON.stringify(payload)
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Request failed');
          return res.json().catch(function () { return {}; });
        })
        .then(function (data) {
          if (data && data.ok === false) throw new Error(data.error || 'Request failed');
          showStatus(statusOk);
          form.reset();
          if (otherWrap) otherWrap.classList.remove('active');
          form.querySelectorAll('.rda-chip.is-checked').forEach(function (el) {
            el.classList.remove('is-checked');
          });
          form.querySelectorAll('.rda-filename').forEach(function (el) {
            el.textContent = DEFAULT_HINT;
          });
        })
        .catch(function () {
          showStatus(statusErr);
        })
        .finally(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        });
    });
  }

  document.querySelectorAll('[id^="rda-"]').forEach(function (root) {
    if (root.querySelector('.rda-form')) init(root);
  });
})();
